// Guest wish list nudge (snippets/pf-wishlist-nudge.liquid). The first Swym add in a
// session shows "Saved on this device. Sign in to keep it everywhere"; Swym's own
// "added to 1 list" note is hidden while it shows so there is one message, not two.
(() => {
  if (window.PF_WISHLIST_NUDGE) return;
  window.PF_WISHLIST_NUDGE = true;
  const template = document.getElementById("PfWishlistNudge");
  if (!template) return;
  const KEY = "plug:wishlist-nudge";
  const SHOW_MS = 6000;
  let toast = null;
  let timer = null;

  const seen = () => {
    try {
      return sessionStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  };
  const remember = () => {
    try {
      sessionStorage.setItem(KEY, "1");
    } catch {}
  };
  const capture = (action) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      window.posthog?.capture?.("plug_wishlist_nudge", { action });
    } catch {}
  };
  const style = () => {
    if (document.getElementById("PfWishlistNudgeStyle")) return;
    const css = document.createElement("style");
    css.id = "PfWishlistNudgeStyle";
    css.textContent = `
.pf-wishlist-nudge{position:fixed;z-index:2147483000;left:50%;bottom:24px;display:flex;align-items:center;gap:14px;width:min(560px,calc(100vw - 24px));padding:14px 12px 14px 18px;border-radius:16px;background:var(--color-forrest-100,#163c3f);box-shadow:0 12px 32px rgb(8 21 22/28%);color:var(--color-chalk,#f4f0ec);transform:translate(-50%,16px);opacity:0;transition:opacity .18s ease,transform .18s ease}
.pf-wishlist-nudge[data-open]{transform:translate(-50%,0);opacity:1}
.pf-wishlist-nudge>svg{flex:none;color:var(--color-mint-100,#4abfa7)}
.pf-wishlist-nudge p{flex:1;margin:0;color:var(--color-chalk,#f4f0ec);font-size:15px;line-height:1.35}
.pf-wishlist-nudge strong{display:block;color:var(--color-chalk,#f4f0ec);font-family:var(--font-heading-family,inherit)}
.pf-wishlist-nudge a.pf-wishlist-nudge__sign-in{flex:none;padding:10px 18px;border-radius:999px;background:var(--color-lime,#c0f675);color:var(--color-forrest-200,#112d2f);font-weight:700;line-height:1.2;text-decoration:none}
.pf-wishlist-nudge a.pf-wishlist-nudge__sign-in:hover{background:#d2fa98;color:var(--color-forrest-200,#112d2f)}
.pf-wishlist-nudge__close{flex:none;display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:none;color:var(--color-chalk,#f4f0ec);cursor:pointer}
.pf-wishlist-nudge a:focus-visible,.pf-wishlist-nudge__close:focus-visible{outline:3px solid var(--color-chalk,#f4f0ec);outline-offset:2px}
html[data-wishlist-nudge-open] .swym-notifications-container{visibility:hidden!important}
@media (max-width:749px){.pf-wishlist-nudge{bottom:12px;gap:10px;padding:12px 8px 12px 14px}.pf-wishlist-nudge p{font-size:14px}}
@media (prefers-reduced-motion:reduce){.pf-wishlist-nudge{transition:none}}`;
    document.head.appendChild(css);
  };
  const close = (action) => {
    clearTimeout(timer);
    document.documentElement.removeAttribute("data-wishlist-nudge-open");
    if (!toast) return;
    toast.removeAttribute("data-open");
    const node = toast;
    toast = null;
    setTimeout(() => node.remove(), 250);
    if (action) capture(action);
  };
  const show = () => {
    if (toast || seen()) return;
    remember();
    style();
    toast = template.content.firstElementChild.cloneNode(true);
    const signIn = toast.querySelector("[data-wishlist-nudge-sign-in]");
    const login = new URL(template.dataset.loginUrl || signIn.href, location.origin);
    login.searchParams.set("return_to", location.pathname + location.search);
    signIn.href = login.href;
    signIn.addEventListener("click", () => capture("sign_in"));
    toast
      .querySelector("[data-wishlist-nudge-close]")
      .addEventListener("click", () => close("dismiss"));
    document.body.appendChild(toast);
    document.documentElement.setAttribute("data-wishlist-nudge-open", "");
    requestAnimationFrame(() => toast?.setAttribute("data-open", ""));
    // Pause the auto-hide while the shopper is pointing at or tabbing into the toast.
    const hold = () => clearTimeout(timer);
    const resume = () => {
      clearTimeout(timer);
      timer = setTimeout(() => close(), SHOW_MS);
    };
    toast.addEventListener("pointerenter", hold);
    toast.addEventListener("focusin", hold);
    toast.addEventListener("pointerleave", resume);
    toast.addEventListener("focusout", resume);
    resume();
    capture("shown");
  };
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && toast) close("dismiss");
  });

  const attach = (swat) => {
    if (!swat?.evtLayer?.addEventListener || !swat.JSEvents?.addedToWishlist) return;
    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
      if (typeof swat.platform?.isLoggedIn === "function" && swat.platform.isLoggedIn()) return;
      show();
    });
  };
  if (window._swat) attach(window._swat);
  else (window.SwymCallbacks = window.SwymCallbacks || []).push(attach);
})();
